import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useTheme, Button } from '@mui/material';

const useStyles = makeStyles((theme)=>({
  main: {
    
  },
  box:{
    maxWidth:'1800px',
    margin:'0 auto',
    padding:'0 20px',
  },
  faqConfigBlockH1:{
    padding:'40px 0 20px 70px',
    fontWeight:'700',
    fontSize:'22px',
  },
  datagridBox: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflowX: 'scroll',
    overflowY: 'hidden',
    border: '1px solid #D3D3D3',
  },
  datagridTop: {
    display: 'flex',
    alignItems: 'center',

    [theme.breakpoints.down(516)]: {
      fontSize:'10px'
    }, 
  },
  datagridTopItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #D3D3D3',
    borderTop:'none',
    padding:'5px 0'
  },
  contBox: {
    display: 'flex',
    alignItems: 'center',
  },
  contBoxItem: {
    textAlign:'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  textLeft: {
    width: '100%', 
    height: '100%', 
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'center', 
    alignItems: 'center'
  },
  textMiddle: {
    width: '100%', 
    height: '100%', 
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'center', 
    alignItems: 'center'
  },

}));

const FaqConfig = () => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const row = [
    {name: 'ID', width: '10%'},
    {name: '제목', width: '50%'},
    {name: 'FAQ', width: '10%'},
    {name: '순서', width: '10%'},
    {name: '관리', width: '20%'},
  ];

  const [data, setData] = useState([
    [{id: 1, data: 1, type: 'textMiddle'}, {id: 1, data: '자주하시는 질문', type: 'textLeft'}, {id: 1, data: 0, type: 'textMiddle'}, {id: 1, data: 0, type: 'textMiddle'}, {id: 1, data: ['수정', '보기', '삭제'], type: 'button'}],
  ])



  return (
    <div>
      <div className={classes.faqConfigBlock}>
        <h1 className={classes.faqConfigBlockH1}>FAQ (기능없음)</h1>
        <div className={classes.box}>
          <div className={classes.datagridBox}>
            <div className={classes.datagridTop}>
              {row.map((item, index) => (
                        <div key={index} className={classes.datagridTopItem} style={{width: item.width}}>
                          {item.name}
                        </div>
              ))}
            </div>
    
            {data.length > 0 && data.map((dataItem, dataIndex) => {
              return(
                      <div key={dataIndex} className={classes.contBox}>
                          {dataItem.map((item, index) => {
                            return(
                                  <div key={index} className={classes.contBoxItem} style={{width: row[index].width}}>
                                    {item.type === 'textLeft' && (
                                      <h3 className={classes.textLeft}>{item.data}</h3>
                                    )}
                                    {item.type === 'textMiddle' && (
                                      <h3 className={classes.textMiddle}>{item.data}</h3>
                                    )}
                                    {item.type === 'button' && 
                                      (
                                        <div style={{width: '100%', height: '100%'}}>
                                          {item.data.map((btnItm, btnIdx) => (<Button key={btnIdx} variant="text" style={{ minWidth:0 }}>{btnItm}</Button>))}
                                        </div>
                                      )
                                    }
    
                                  </div>
                          )})}
                      </div>
            )})}
    
          </div>
        </div>
      </div>
    </div>
  )
}

export default FaqConfig
